<ngx-loading [show]="loading"></ngx-loading>
<div id="wrapper" #wrapper [ngStyle]="{ 'padding-top': navigation?.nActiveFilters ? '30px' : '0' }" cdkDropListGroup>
  <div>
    <div
      style="position: absolute; gap: 240px"
      class="flag-managing d-flex flex justify-content-between"
      *ngIf="managingGroups">
      <div>
        <h3 style="float: left; line-height: 40px; font-size: 14px; margin: 0">
          Groups selected: {{ selectedGroups.length }}
        </h3>
      </div>

      <div class="d-flex" style="width: fit-content; text-align: end; gap: 16px">
        <button class="btn btn-aru-icon" [disabled]="!selectedGroups.length" (click)="removeSelected()">
          <img src="assets/img/delete.svg" alt="" />
          <span>Delete</span>
        </button>
        <button class="btn btn-aru btn-outline-dark" [disabled]="!canMerge()" (click)="mergeGroups()">
          <span>Merge groups</span>
        </button>
        <div class="cross" (click)="managingGroups = false" style="padding: 0">
          <img src="assets/img/x.svg" alt="" />
        </div>
      </div>
    </div>

    <div
      style="position: absolute; gap: 142px"
      class="flag-managing flex d-flex justify-content-between"
      *ngIf="selectedFlags?.length && !managingGroups">
      <div>
        <h3 style="float: left; line-height: 40px; font-size: 14px; margin: 0">
          Flags selected: {{ selectedFlags.length }}
        </h3>
        <div style="display: flex; width: 20%">
          <button class="btn btn-link" style="flex: none" (click)="selectAll()">Select all / Deselect all</button>
        </div>
      </div>
      <div class="d-flex">
        <div *ngIf="!changeStatus" class="d-flex" style="width: fit-content; text-align: end; gap: 16px">
          <button class="btn btn-aru-icon" [disabled]="!canGroupFlags()" (click)="groupFlags()" *ngIf="!selectedGroup">
            <img src="assets/img/link.svg" alt="" />
            <span>Group flags</span>
          </button>
          <button class="btn btn-aru-icon" (click)="ungroupFlags()" *ngIf="selectedGroup">
            <img src="assets/img/link.svg" alt="" />
            <span>Unlink flags</span>
          </button>
          <button
            class="btn btn-aru-icon"
            (click)="applyTemplate(); $event.stopPropagation()"
            *ngIf="!allSelectedAreExcluded() && (underwritingStatus == '1' || underwritingStatus == '2')">
            <img src="assets/img/templates.svg" alt="" />
            <span>Group from template</span>
          </button>

          <button
            class="btn btn-aru btn-outline-dark"
            (click)="ExtensionGrantedDeadlines(); $event.stopPropagation()"
            [disabled]="hasNonDiscrepancyFlag()"
            *ngIf="!allSelectedAreExcluded() && (underwritingStatus == '3' || underwritingStatus == '4')"
            style="max-width: 175px; text-wrap: nowrap">
            Grant extension
          </button>
          <button
            *ngIf="allFlags?.length && activeStep == 3"
            class="btn btn-aru btn-outline-dark"
            (click)="changeStatus = !changeStatus">
            Change status
          </button>
          <button class="btn btn-aru btn-outline-dark" (click)="ignoreFlags()" *ngIf="!allSelectedAreExcluded()">
            Ignore
          </button>
          <button class="btn btn-aru btn-outline-dark" (click)="keepFlags()" *ngIf="allSelectedAreExcluded()">
            Keep
          </button>
        </div>

        <div
          *ngIf="changeStatus && allFlags?.length && activeStep == 3"
          class="d-flex"
          style="width: fit-content; text-align: end; gap: 16px">
          <button
            type="button"
            class="btn btn-aru btn-outline-danger"
            (click)="changeFlagStatusBulk(FlagStatus.UNRESOLVED); $event.stopPropagation()">
            Unresolved
          </button>
          <button
            type="button"
            (click)="changeFlagStatusBulk(FlagStatus.PARTIAL_RESPONSE)"
            class="btn btn-aru btn-outline-warning">
            Partial Response
          </button>
          <button
            [disabled]="loading"
            type="button"
            class="btn btn-aru btn-outline-success"
            (click)="changeFlagStatusBulk(FlagStatus.RESOLVED); $event.stopPropagation()">
            Resolved
          </button>
        </div>
        <div class="cross" (click)="uncheckAllFlags()">
          <img src="assets/img/x.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
  <div class="main">
    <div id="left-column">
      <div class="item-column">
        <div class="column-header">
          <h4 style="float: left">
            <span style="float: left">Groups</span>
          </h4>
          <!-- *ngIf="!managingGroups && activeStep == 1"  -->
          <a [routerLink]="[]" style="float: right; font-weight: 600" (click)="managingGroups = true">Manage groups</a>
          <br style="clear: both" />

          <div style="color: #666; font-size: 15px; margin: 10px 0" *ngIf="allFlags?.length && activeStep == 1">
            <span style="font-weight: 700; float: left"
              ><span>{{ nCompletedFlags() }}/{{ allFlags?.length }}</span> flags left</span
            >

            <span style="float: right">
              <div class="progress" style="display: inline-flex; width: 70px; margin: 0 10px 0 0; height: 5px">
                <div
                  class="progress-bar"
                  role="progressbar"
                  [ngStyle]="{ width: (100 * nCompletedFlags()) / allFlags?.length + '%' }"></div>
              </div>
              <span>{{ ((100 * nCompletedFlags()) / allFlags?.length).toFixed(0) }}%</span>
            </span>
          </div>

          <div style="color: #666; font-size: 15px; margin: 10px 0" *ngIf="allFlags?.length && activeStep == 3">
            <span style="float: left; font-weight: 700">
              {{ totalResolved + totalPartiallyResponse }}/{{ allFlags?.length }}
              flags left
            </span>

            <span style="float: right">
              <div
                class="progress"
                style="display: inline-flex; width: 70px; margin: 0 10px 0 0; height: 5px; font-weight: 700">
                <div
                  class="progress-bar green"
                  role="progressbar"
                  [ngStyle]="{ width: (100 * totalResolved) / allFlags?.length + '%' }"></div>
                <div
                  class="progress-bar yellow"
                  role="progressbar"
                  [ngStyle]="{ width: (100 * totalPartiallyResponse) / allFlags?.length + '%' }"></div>
                <div
                  class="progress-bar red"
                  role="progressbar"
                  [ngStyle]="{ width: (100 * totalUnResolve) / allFlags?.length + '%' }"></div>
              </div>
              <span>{{ ((100 * (totalResolved + totalPartiallyResponse)) / allFlags?.length).toFixed(0) }}%</span>
            </span>
          </div>

          <div
            class="d-flex flex"
            style="float: left; font-size: 13px; margin: 10px 0"
            *ngIf="allFlags?.length && activeStep == 3">
            <div style="color: #4dbd74; letter-spacing: 0px">
              <span style="font-weight: 600">
                {{ totalResolved }}
                <!-- /{{allFlags?.length}} --> </span
              >resolved
            </div>
            <div class="pl-3" style="color: #ffc107; letter-spacing: 0px">
              <span style="font-weight: 600">
                {{ totalPartiallyResponse }}
                <!-- /{{allFlags?.length}} --> </span
              >partial response
            </div>
            <div class="pl-3" style="color: #dc3e3e; letter-spacing: 0px">
              <span style="font-weight: 600">
                {{ totalUnResolve }}
                <!-- /{{allFlags?.length}} --> </span
              >unresolved
            </div>
          </div>

          <br style="clear: both" />

          <hr />
        </div>
        <div id="flagGroups" class="scrollable" [perfectScrollbar]>
          <div [ngClass]="{ selected: !selectedGroup }">
            <div
              class="flag flag-info red"
              (click)="openGroup(null)"
              cdkDropList
              [cdkDropListEnterPredicate]="notSameGroupPredicate"
              (cdkDropListDropped)="flagDropped($event, null)">
              <div style="position: relative">
                <div class="icon-left" *ngIf="!isCompleted(null)">
                  <i class="fa fa-warning"></i>
                </div>
                <div class="completed" *ngIf="isCompleted(null)">
                  <i class="fa fa-check"></i>
                </div>
              </div>
              <div style="flex: 1; padding: 0 20px" class="middle-text">
                <p class="main-text">Uncategorized</p>
                <p style="margin: 0 0 10px; font-size: 13px">{{ countUncategorized || 0 }} flags</p>
              </div>
              <div style="color: #2663cd"><i class="fa fa-chevron-right"></i></div>
              <span class="warning-msg">The flag is already in this group</span>
            </div>
          </div>

          <ng-container *ngFor="let group of groups; let index = index">
            <div style="display: flex" [ngClass]="{ selected: selectedGroup == group }">
              <div style="padding-right: 20px" [ngStyle]="{ display: managingGroups ? 'block' : 'none' }">
                <input
                  type="checkbox"
                  [formControl]="group.checkbox"
                  class="form-control"
                  style="margin: auto; width: 25px" />
                <div class="group-arrows">
                  <i class="fa fa-arrow-up" *ngIf="index" (click)="moveGroupUp(index)"></i>
                  <i class="fa fa-arrow-down" *ngIf="index < groups.length - 1" (click)="moveGroupDown(index)"></i>
                </div>
              </div>
              <div
                class="flag flag-info blue"
                style="flex: 1"
                (click)="openGroup(group)"
                cdkDropList
                [cdkDropListData]="group"
                (cdkDropListDropped)="flagDropped($event, group)"
                [cdkDropListEnterPredicate]="sameTypePredicate.bind(this)">
                <div style="position: relative">
                  <div class="icon-left" *ngIf="!isCompleted(group)">
                    <i class="fa fa-warning"></i>
                  </div>
                  <div class="completed" *ngIf="isCompleted(group)">
                    <i class="fa fa-check"></i>
                  </div>
                </div>
                <div style="flex: 1; padding: 0 20px" class="middle-text">
                  <p class="main-text">{{ group.name }}</p>
                  <p style="margin: 0 0 10px; font-size: 13px">
                    {{ group.count }} flags
                    <span *ngIf="group.subtype?.type" class="group-type">{{ group.subtype.type.name }}</span>
                  </p>
                </div>
                <div style="color: #2663cd; display: flex; flex-direction: column">
                  <div style="flex: 1; text-align: right">
                    <i class="fa fa-chevron-right"></i>
                  </div>
                  <div class="edit-icons main-text icon-color" *ngIf="activeStep == 1">
                    <i class="fa fa-pencil" (click)="editGroup(group)"></i>
                    <i class="fa fa-trash" (click)="removeGroup(group)"></i>
                  </div>
                </div>
                <span class="warning-msg" *ngIf="selectedGroup == group">The flag is already in this group</span>
                <span class="warning-msg" *ngIf="selectedGroup != group"
                  >Groups can't have more than one flag type</span
                >
              </div>
            </div>
          </ng-container>

          <div *ngIf="activeStep == 1" class="add-group" (click)="addGroup()">
            <span class="plus-sign">+</span> <span>Add group</span>
          </div>
        </div>
      </div>
    </div>

    <div id="right-column">
      <div id="group-header" class="d-flex justify-content-between align-items-start">
        <div class="group-header-info mr-5 w-100" style="max-width: 650px">
          <span class="d-flex flex justify-content-between gap-1 flex-wrap mb-3">
            <h3>Reviewing inspection #{{ inspection?.id }}</h3>
            <a class="font-weight-bold" [routerLink]="[]" (click)="toggleComments()">
              <a href="javascript:void(0);" class="list-toggler"><i class="fa fa-comment" aria-hidden="true"></i></a>
              Review comments <span> ({{ allCommentsLength ? allCommentsLength : '0' }})</span>
            </a>
          </span>

          <div class="inspection-id d-flex align-items-center flex-wrap mb-2 justify-content-between">
            <p class="flex align-items-center flex-wrap">
              Customer:{{ inspection?.customerName }} &nbsp;
              <span class="ml-1">Policy number:{{ inspection?.policyNumber }}</span>
            </p>
            <div class="ngx-select select-primary">
              <div class="btn-group" [ngClass]="getClassByUnderwritingStatus()" dropdown>
                <button
                  id="button-basic"
                  dropdownToggle
                  type="button"
                  class="dropdown-toggle"
                  aria-controls="dropdown-basic"
                  aria-controls="dropdown-basic">
                  {{ underwritingStatusMapping[underwritingStatus] || 'Select Option' }}
                  <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>

                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                  <li class="item-primary">
                    <a class="dropdown-item" (click)="underwritingStatus = '1'">Prepare flags for rec letter</a>
                  </li>
                  <li class="item-success">
                    <a class="dropdown-item" (click)="underwritingStatus = '2'">Flags preparation in progress</a>
                  </li>
                  <li class="item-warning">
                    <a class="dropdown-item" (click)="underwritingStatus = '3'">Rec letter sent to customer</a>
                  </li>
                  <li class="item-danger">
                    <a class="dropdown-item" (click)="underwritingStatus = '4'">Resolution in progress</a>
                  </li>
                  <li class="item-primary"><a class="dropdown-item" (click)="underwritingStatus = '5'">Closed</a></li>
                </ul>
              </div>

              <!-- <select [(ngModel)]="underwritingStatus" class="form-control" style="display: inline; width: unset">
                <option class="text-white bg-danger" [value]="UnderwritingStatus.PREPARE_FLAGS">
                  Prepare flags for rec letter</option>
                <option [value]="UnderwritingStatus.PREPARATION_IN_PROGRESS">Flags preparation in
                  progress
                </option>
                <option [value]="UnderwritingStatus.LETTER_SENT">Rec letter sent to customer</option>
                <option [value]="UnderwritingStatus.RESOLUTION_IN_PROGRESS">Resolution in progress
                </option>
                <option [value]="UnderwritingStatus.CLOSED">Closed</option>
              </select> -->
            </div>
          </div>
          <a *ngIf="isBeforeLetterSent()" [routerLink]="[]" (click)="setDeadlines()">Violation deadlines</a>
        </div>
        <div class="steps d-flex align-items-center">
          <div
            [ngClass]="{ 'step-fade': activeStep != 1, 'step-enabled': stepEnabled(1) }"
            (click)="stepEnabled(1) && (activeStep = 1)">
            <span>1</span>
            <p>Add info or group flags</p>
          </div>

          <div class="step-fade" style="cursor: default">
            <span>2</span>
            <p>Create and send report</p>
          </div>

          <div
            [ngClass]="{ 'step-fade': activeStep != 3, 'step-enabled': stepEnabled(3) }"
            (click)="stepEnabled(3) && (activeStep = 3)">
            <span>3</span>
            <p>Resolve and close flags</p>
          </div>
        </div>
        <div *ngIf="showReportButton()">
          <button [disabled]="generatingDoc" type=" button" class="btn aru btn-primary" (click)="generateDoc()">
            {{ generatingDoc ? 'Loading' : 'Generate report' }}
          </button>
        </div>
      </div>
      <!-- Body -->
      <div class="d-flex align-items-center justify-content-between gap-3">
        <div class="inspection-body-h-info d-flex align-items-start">
          <i
            class="fa fa-flag"
            style="
              background-color: #2763cd33;
              color: #2763cd;
              border-radius: 50%;
              padding: 7px;
              font-size: 15px;
              margin-right: 10px;
            "></i>
          <div>
            <h3 style="color: #2763cd">
              {{ selectedGroup?.name || 'Uncategorized' }}
            </h3>
            <span style="color: #aaa"> • {{ selectedGroup ? selectedGroup.count : countUncategorized }} flags </span>
          </div>
        </div>
        <div class="inspection-body-h-tools d-flex align-items-center gap-4 flex-grow-1 justify-content-end">
          <div
            *ngIf="selectedGroup && activeStep == 1"
            class="d-flex align-items-center flex-grow-1 justify-content-center">
            <button
              type=" button"
              class="btn aru btn-outline-primary add-group-level-btn"
              (click)="editGroup(selectedGroup)">
              Add group level info
            </button>
            <button
              [disabled]="!selectedGroup?.count"
              type=" button"
              class="btn aru btn-outline-primary unlike-all-btn"
              (click)="unlinkAllFromSelectedGroup()">
              Unlink all
            </button>
          </div>
          <div class="d-flex align-items-center gap-3">
            <div class="d-flex align-items-center">
              <span class="mr-2 custom-switch-heading">System flags only</span>
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="customSwitch1" checked />
                <label class="custom-control-label" for="customSwitch1"></label>
              </div>
            </div>
            <div class="listing-toggler">
              <a href="javascript:void(0);" class="list-toggler disabled"
                ><i class="fa fa-list" aria-hidden="true"></i
              ></a>
              <a href="javascript:void(0);" class="grid-toggler disabled"
                ><i class="fa fa-th" aria-hidden="true"></i
              ></a>
            </div>
          </div>
        </div>
      </div>

      <!-- Grid -->
      <!-- 01 -->
      <div *ngIf="activeStep == 1" class="scrollable" #flagListStep1>
        <div
          *ngIf="!currentFlags?.length"
          style="font-size: 25px; font-weight: bold; margin-top: 25%; text-align: center">
          This group doesn't have any flags yet.
          <br />
          Drag flags here from other groups.
        </div>
        <div *ngIf="currentFlags?.length" class="for-scroll">
          <br />
          <h4 class="flag-status-buttons sticky-header">
            To be added
            <span style="color: #2763cd">({{ kept.length }}) </span>
          </h4>
          <div *ngIf="!kept?.length" style="font-size: 20px; font-weight: bold; text-align: center">
            None of the flags below will be included in the report.
            <br />
            Click "Keep" next to any of the flags to include them in the report.
          </div>
          <ng-container *ngIf="kept?.length">
            <div cdkDropList [cdkDropListEnterPredicate]="noReturnPredicate" cdkDropListSortingDisabled>
              <ng-container *ngFor="let flag of kept; index as i">
                <div cdkDrag [cdkDragData]="flag" class="kept-listing" [attr.id]="'flag-' + flag.id">
                  <div class="custom-placeholder" *cdkDragPlaceholder></div>
                  <div *cdkDragPreview class="custom-preview">
                    <div class="flag-picture" *ngIf="flag.picture">
                      <div class="no-picture" *ngIf="!flag.picture">No picture</div>
                      <div *ngIf="flag.picture">
                        <img
                          style="max-width: 100%; max-height: 250px"
                          class="thumb-markup"
                          [src]="embeddedUrl(flag.picture) + '?'" />
                      </div>
                    </div>
                    <div class="middle">
                      <p class="flag-path" style="font-weight: bold">{{ flag.label }}</p>
                      <p class="main-text">{{ flag.question }}</p>
                      <p class="description" style="font-style: italic">{{ flag.text }}</p>
                      <p style="margin: 0 0 10px 0; font-size: 13px; color: #7b8ead; float: left">
                        <span class="username">{{ flag.user?.name }}</span> &nbsp;
                        {{ dateTimeAsString(flag.updatedAt) }}
                      </p>
                      <span class="flag-type" style="margin-top: 10px; clear: both">{{
                        flag.subtype?.type?.name
                      }}</span>
                    </div>
                  </div>

                  <ng-container
                    *ngTemplateOutlet="
                      flagInfo;
                      context: { $implicit: { flag: flag, selectedGroup: selectedGroup, inspection: inspection } }
                    ">
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <br />
          <h4>
            Excluded <span style="color: #2763cd">({{ ignored.length }})</span>
          </h4>
          <div *ngIf="!ignored?.length" style="font-size: 20px; font-weight: bold; text-align: center">
            All the above flags will be included in the report.
            <br />
            Click "Ignore" next to any of the flags to exclude them.
          </div>
          <ng-container *ngIf="ignored?.length">
            <div cdkDropList [cdkDropListEnterPredicate]="noReturnPredicate" cdkDropListSortingDisabled>
              <ng-container *ngFor="let flag of ignored; index as i">
                <ng-container
                  *ngTemplateOutlet="
                    flagInfo;
                    context: { $implicit: { flag: flag, selectedGroup: selectedGroup, inspection: inspection } }
                  ">
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>

      <div *ngIf="activeStep == 3" class="step3">
        <div class="sticky-header">
          <div class="aru-tabs mt-4" style="text-align: start; font-weight: 700">
            <button
              (click)="scrollToSection('un-resolved')"
              type="button"
              [ngClass]="getClass('UnResolved')"
              class="btn btn-square text-black">
              <span
                >Unresolved <span class="text-primary"> ({{ this.unResolved.length }})</span>
              </span>
            </button>
            <button
              (click)="scrollToSection('partial-response')"
              type="button"
              [ngClass]="getClass('Partial Response')"
              class="btn btn-square text-black">
              <span
                >Partial Response <span class="text-primary"> ({{ this.partialResponse.length }}) </span></span
              ></button
            ><button
              (click)="scrollToSection('resolved')"
              type="button"
              [ngClass]="getClass('Resolved')"
              class="btn btn-square text-black">
              <span
                >Resolved <span class="text-primary"> ({{ this.resolved.length }})</span>
              </span>
            </button>
          </div>
          <div></div>
        </div>

        <h4 class="sticky-header">
          {{ stickyTitle }}
          <span style="color: #2763cd">({{ stickySize }})</span>
        </h4>
      </div>

      <div
        *ngIf="activeStep == 3"
        class="forscroll scrollable step3"
        #flagListStep3
        [perfectScrollbar]
        (scroll)="handleScroll($event)">
        <div
          *ngIf="!currentFlags?.length"
          style="font-size: 25px; font-weight: bold; margin-top: 25%; text-align: center">
          This group doesn't have any flags yet.
          <br />
          Drag flags here from other groups.
        </div>

        <div *ngIf="currentFlags?.length">
          <div class="un-resolved">
            <div
              *ngIf="!unResolved?.length"
              style="font-size: 20px; font-weight: bold; text-align: center; padding: 25px">
              None of the flags have this status.
            </div>

            <ng-container *ngIf="unResolved?.length">
              <div>
                <ng-container *ngFor="let flag of unResolved; index as i">
                  <ng-container
                    *ngTemplateOutlet="
                      flagResolution;
                      context: { $implicit: { flag: flag, selectedGroup: selectedGroup, inspection: inspection } }
                    ">
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>
            <br />
          </div>

          <div class="partial-response">
            <h4 class="sticky-header step3-status">
              Partial Response <span style="color: #2763cd">({{ partialResponse.length }})</span>
            </h4>

            <div
              *ngIf="!partialResponse?.length"
              style="font-size: 20px; font-weight: bold; text-align: center; padding: 25px">
              None of the flags have this status.
            </div>

            <ng-container *ngIf="partialResponse?.length">
              <div>
                <ng-container *ngFor="let flag of partialResponse; index as i">
                  <ng-container
                    *ngTemplateOutlet="
                      flagResolution;
                      context: { $implicit: { flag: flag, selectedGroup: selectedGroup, inspection: inspection } }
                    ">
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>
            <br />
          </div>

          <div class="resolved">
            <h4 class="sticky-header step3-status">
              Resolved<span style="color: #2763cd">({{ resolved.length }})</span>
            </h4>

            <div
              *ngIf="!resolved?.length"
              style="font-size: 20px; font-weight: bold; text-align: center; padding: 25px">
              None of the flags have this status.
            </div>

            <ng-container *ngIf="resolved?.length">
              <div>
                <ng-container *ngFor="let flag of resolved; index as i">
                  <ng-container
                    *ngTemplateOutlet="
                      flagResolution;
                      context: { $implicit: { flag: flag, selectedGroup: selectedGroup, inspection: inspection } }
                    ">
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>
            <br />
          </div>
        </div>
        <br />
      </div>
    </div>
    <div class="side-form" *ngIf="editingGroup || editingFlag">
      <span class="close" (click)="editingGroup = null; editingFlag = null"></span>
      <br />

      <app-add-group
        *ngIf="editingGroup && !editingGroup.id"
        (groupAdded)="groupSaved($event)"
        style="padding: 0 30px 0 40px; display: block; width: 100%"
        [inspection]="inspection"
        [flagGroupTags]="flagGroupTags"
        (cancel)="editingGroup = null">
      </app-add-group>

      <div *ngIf="editingGroup?.id" style="display: flex; flex-direction: column; width: 100%">
        <h2 style="padding: 10px 0 20px 40px" *ngIf="!flagChangelog">Group Details</h2>
        <h2 style="padding: 10px 0 20px 40px" *ngIf="flagChangelog">Flag Changelog</h2>

        <div
          *ngIf="!flagChangelog"
          class="accordion-button"
          [ngClass]="{ active: accordion.active == 'details' }"
          (click)="accordion.toggle('details')">
          <div style="flex: 1">Details</div>
          <i
            class="fa"
            [ngClass]="{
              'fa-chevron-down': accordion.active !== 'details',
              'fa-chevron-up': accordion.active == 'details'
            }"></i>
        </div>

        <div style="padding: 20px 30px 0 40px; flex: 1" *ngIf="accordion.active == 'details'">
          <app-edit-group
            (groupSaved)="groupSaved($event)"
            [group]="editingGroup"
            [flagGroupTags]="flagGroupTags"
            (cancel)="editingGroup = null; editingFlag = null"
            [readOnly]="activeStep == 3"
            [allGroups]="groups"
            (messageEvent)="updateData($event)"
            (editGroup)="editGroupByTemplate($event)">
          </app-edit-group>
        </div>

        <div
          *ngIf="!editingGroup?.id"
          class="accordion-button"
          [ngClass]="{ active: true }"
          (click)="accordion.toggle('changelog')">
          <div style="flex: 1">
            Changelog <span style="color: #2763cd">({{ editingGroupChanges?.length || 0 }})</span>
          </div>
          <i
            class="fa"
            [ngClass]="{
              'fa-chevron-down': accordion.active !== 'changelog',
              'fa-chevron-up': accordion.active == 'changelog'
            }"></i>
        </div>

        <div class="scrollable" *ngIf="accordion.active == 'changelog'" style="padding: 30px" [perfectScrollbar]>
          <div
            style="
              margin-left: 15px;
              color: #3465c4;
              padding: 0 0 20px 0;
              display: flex;
              text-align: left;
              border-left: 3px solid #dae5f9;
              position: relative;
            "
            *ngFor="let c of editingFlag.changes; index as i">
            <i
              style="
                position: absolute;
                top: 0;
                left: -13px;
                padding: 5px;
                border-radius: 50%;
                background-color: #dae5f9;
                color: #93baff;
              "
              class="fa fa-pencil"></i>

            <div style="flex: 1; padding: 0 20px">
              <p style="font-weight: bold; margin: 0 0 4px">
                {{ c.username }}

                <span
                  *ngIf="c.user"
                  style="
                    background-color: #fff;
                    height: 30px;
                    border-radius: 15px;
                    padding: 3px 8px;
                    font-weight: bold;
                    font-weight: 10px;
                  ">
                  {{ c.user.type === 'AdminUser' ? 'Admin' : c.user?.type }}
                </span>
                <span style="color: #2763cd; margin: 0; font-size: 11px; float: right; line-height: 21px">
                  {{ dateTimeAsString(c.date) }}
                </span>
              </p>

              <div style="color: #444; margin: 0; font-size: 13px; cursor: pointer">
                <ul>
                  <li *ngFor="let change of c.changes | keyvalue">
                    {{ change.key }}

                    <ul *ngIf="change.value">
                      <li *ngIf="change.value.before">From: {{ change.value.before }}</li>
                      <li *ngIf="!change.value.before">From: <i>empty</i></li>
                      <li *ngIf="change.value.after">To: {{ change.value.after }}</li>
                      <li *ngIf="!change.value.after">To: <i>empty</i></li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="editingFlag && !editingGroup" style="display: flex; flex-direction: column; width: 100%">
        <h2 style="padding: 10px 0 20px 40px">Flag Details</h2>

        <div
          class="accordion-button"
          [ngClass]="{ active: accordion.active == 'details' }"
          (click)="accordion.toggle('details')">
          <div style="flex: 1">Details</div>
          <i
            class="fa"
            [ngClass]="{
              'fa-chevron-down': accordion.active !== 'details',
              'fa-chevron-up': accordion.active == 'details'
            }"></i>
        </div>

        <div style="padding: 10px 30px 0 40px; flex: 1" *ngIf="accordion.active == 'details'">
          <app-edit-flag-details
            [flag]="editingFlag"
            (flagChanged)="updateFlag($event)"
            [hideDelete]="true"
            (requestEdit)="editRequested()"
            (flagDeleted)="removeFlag($event)"
            [readOnly]="activeStep == 3">
          </app-edit-flag-details>
        </div>

        <div
          class="accordion-button"
          [ngClass]="{ active: accordion.active == 'changelog' }"
          (click)="accordion.toggle('changelog')">
          <div style="flex: 1">
            Changelog <span style="color: #2763cd">({{ editingFlag?.changes?.length || 0 }})</span>
          </div>
          <i
            class="fa"
            [ngClass]="{
              'fa-chevron-down': accordion.active !== 'changelog',
              'fa-chevron-up': accordion.active == 'changelog'
            }"></i>
        </div>

        <div
          class="scrollable"
          *ngIf="accordion.active == 'changelog'"
          style="padding: 30px; flex: 1"
          [perfectScrollbar]>
          <div
            style="
              margin-left: 15px;
              color: #3465c4;
              padding: 0 0 20px 0;
              display: flex;
              text-align: left;
              border-left: 3px solid #dae5f9;
              position: relative;
            "
            *ngFor="let c of editingFlag.changes; index as i">
            <i
              style="
                position: absolute;
                top: 0;
                left: -13px;
                padding: 5px;
                border-radius: 50%;
                background-color: #dae5f9;
                color: #93baff;
              "
              class="fa fa-pencil"></i>

            <div style="flex: 1; padding: 0 20px">
              <p style="font-weight: bold; margin: 0 0 4px">
                {{ c.username }}
                <span
                  *ngIf="c.user"
                  style="
                    background-color: #fff;
                    height: 30px;
                    border-radius: 15px;
                    padding: 3px 8px;
                    font-weight: bold;
                    font-weight: 10px;
                  ">
                  {{ c.user.type === 'AdminUser' ? 'Admin' : c.user?.type }}
                </span>
                <span style="color: #2763cd; margin: 0; font-size: 11px; float: right; line-height: 21px">
                  {{ dateTimeAsString(c.date) }}
                </span>
              </p>

              <div style="color: #444; margin: 0; font-size: 13px; cursor: pointer">
                <ul>
                  <li *ngFor="let change of c.changes | keyvalue">
                    {{ change.key }}

                    <ul *ngIf="change.value">
                      <li *ngIf="change.value.before">From: {{ change.value.before }}</li>
                      <li *ngIf="!change.value.before">From: <i>empty</i></li>
                      <li *ngIf="change.value.after">To: {{ change.value.after }}</li>
                      <li *ngIf="!change.value.after">To: <i>empty</i></li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="activeStep == 3 && ctx"
          class="accordion-button"
          [ngClass]="{ active: accordion.active == 'comments' }"
          (click)="accordion.toggle('comments')">
          <div style="flex: 1">
            Underwriting Comments
            <span class="text-primary">({{ ctx.flag?.comments?.length ? ctx.flag?.comments?.length : '0' }})</span>
          </div>
          <i
            class="fa"
            [ngClass]="{
              'fa-chevron-down': accordion.active !== 'comments',
              'fa-chevron-up': accordion.active == 'comments'
            }"></i>
        </div>

        <div
          *ngIf="activeStep == 3 && accordion.active == 'comments'"
          style="position: relative; flex: 1; border-bottom: 1px solid #dce6f5; min-height: 200px">
          <div class="accordion" [perfectScrollbar]>
            <form (submit)="addComment(newComment.value); newComment.value = ''">
              <div class="form-group" style="position: relative">
                <input
                  type="text"
                  class="form-control"
                  style="padding: 10px 30px 10px 10px"
                  placeholder="Add new Comment"
                  #newComment />
                <button type="submit" class="btn" style="position: absolute; top: 0; right: 0px; color: #2763cd">
                  <i class="fa fa-arrow-right"></i>
                </button>
              </div>
            </form>

            <div
              style="
                background-color: #dee7f5;
                border-radius: 4px;
                color: #3465c4;
                padding: 15px;
                margin-bottom: 15px;
                display: flex;
                text-align: left;
              "
              *ngFor="let comment of editingFlag.comments; index as i">
              <div>
                <i class="fa fa-comment"></i>
              </div>
              <div style="flex: 1; padding: 0 20px">
                <p style="font-weight: bold; margin: 0 0 10px">{{ comment.text }}</p>
                <p style="color: #444; margin: 0; font-size: 13px">
                  {{ dateAsString(comment.date) }} / {{ comment.username }}
                </p>
              </div>
              <div>
                <i style="cursor: pointer" class="fa fa-trash" (click)="removeComment(i)"></i>
              </div>
            </div>
          </div>
        </div>

        <div
          class="accordion-button"
          [ngClass]="{ active: accordion.active == 'comments-review' }"
          (click)="accordion.toggle('comments-review')">
          <div style="flex: 1">
            Review Comments
            <span style="color: #2763cd">({{ getQuestionCommentsTotal(editingFlag?.questionId) }})</span>
          </div>
          <i
            class="fa"
            [ngClass]="{
              'fa-chevron-down': accordion.active !== 'comments-review',
              'fa-chevron-up': accordion.active == 'comments-review'
            }"></i>
        </div>
        <div
          *ngIf="accordion.active == 'comments-review'"
          style="position: relative; flex: 1; border-bottom: 1px solid #dce6f5; min-height: 200px">
          <div class="accordion" [perfectScrollbar]>
            <div
              *ngFor="let comment of getQuestionComments(editingFlag?.questionId)"
              style="
                background-color: #dee7f5;
                border-radius: 4px;
                color: #3465c4;
                padding: 15px;
                margin-bottom: 15px;
                display: flex;
                text-align: left;
              ">
              <div><i class="fa fa-comment"></i></div>
              <div style="flex: 1; padding: 0 20px">
                <p style="font-weight: bold; margin: 0 0 10px">{{ comment.text }}</p>
                <p style="color: #444; margin: 0; font-size: 13px">
                  {{ dateAsString(comment.date) }} / {{ comment.username }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="side-form"
      *ngIf="inspection && answers"
      [hidden]="!showComments"
      style="overflow: hidden; overflow-y: auto; flex: 1 1 auto">
      <span class="close" (click)="showComments = !showComments"></span><br />
      <app-inspection-comment
        [inspection]="inspection"
        [answers]="answers"
        (allCommentsLength)="allCommentsLength = $event"></app-inspection-comment>
    </div>
  </div>

  <div
    *ngIf="selectedPicture"
    style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      z-index: 1020;
      display: flex;
    ">
    <div style="flex: 1">
      <app-picture-viewer
        [picture]="selectedPicture"
        [flags]="[selectedFlag]"
        (moveFlag)="moveFlag($event)"
        (blobLoaded)="loadExif($event)"
        (markupChanged)="updateThumb($event)">
      </app-picture-viewer>

      <i
        (click)="selectedPicture = false"
        class="fa fa-arrow-left"
        style="
          text-shadow: 0px 0px 3px #000;
          color: #fff;
          cursor: pointer;
          position: absolute;
          top: 15px;
          left: 65px;
          font-size: 25px;
          z-index: 400;
        "></i>

      <div style="position: absolute; top: 30px; right: 10px; padding: 10px; font-size: 20px">
        <i
          (click)="showInfo()"
          class="fa fa-info"
          style="text-shadow: 0px 0px 3px #000; cursor: pointer; color: white"></i>
      </div>

      <div
        style="
          position: absolute;
          bottom: 10px;
          left: 10px;
          padding: 10px;
          font-size: 15px;
          text-shadow:
            0 0 10px #000,
            0 0 10px #000,
            0 0 10px #000,
            0 0 10px #000;
          color: #fff;
          width: 100%;
          z-index: 400;
        ">
        {{ dateFromExif() }}
      </div>
    </div>
  </div>

  <div
    bsModal
    #overrideOptions="bs-modal"
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <p>
            Since the group doesn't have any information added, we will use the flag-level information for the group. Do
            you want to continue?
          </p>
        </div>
        <div class="modal-footer" style="justify-content: left">
          <button type="button" class="btn btn-primary" (click)="overrideOptionResolver(OverrideOption.USE_FLAG_INFO)">
            Confirm
          </button>
          <button type="button" class="btn btn-secondary" (click)="overrideOptionResolver(OverrideOption.ADD_EMPTY)">
            Add as Empty
          </button>
          <button type="button" class="btn" (click)="overrideOptionResolver(OverrideOption.CANCEL)">Cancel</button>
        </div>
      </div>
    </div>
  </div>

  <div
    bsModal
    #unlinkAllOptions="bs-modal"
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <p>Do you want to keep all group information?</p>
        </div>
        <div class="modal-footer" style="justify-content: left">
          <button type="button" class="btn btn-primary" (click)="unlinkAllOptionResolver(UnlinkAllOption.KEEP)">
            Confirm
          </button>
          <button type="button" class="btn btn-secondary" (click)="unlinkAllOptionResolver(UnlinkAllOption.CLEAR)">
            Unlink all and clear group info
          </button>
          <button type="button" class="btn" (click)="unlinkAllOptionResolver(UnlinkAllOption.CANCEL)">Cancel</button>
        </div>
      </div>
    </div>
  </div>

  <div
    bsModal
    #lastFlagOptions="bs-modal"
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <p>The group is now empty. Do you want to keep all group information?</p>
        </div>
        <div class="modal-footer" style="justify-content: left">
          <button type="button" class="btn btn-primary" (click)="lastFlagOptionResolver(LastFlagOption.KEEP)">
            Keep group info
          </button>
          <button type="button" class="btn btn-secondary" (click)="lastFlagOptionResolver(LastFlagOption.CLEAR)">
            Clear group info
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-group-picker #groupPicker></app-group-picker>
</div>

<ng-template #flagInfo let-ctx>
  <div class="flag-details kept-listing" [ngClass]="getFlagHighlightClass(ctx.flag)">
    <div class="flag-picture">
      <div style="position: absolute">
        <label class="checkbox-container">
          <input
            type="checkbox"
            class="checkbox-input"
            [formControl]="ctx.flag.checkbox"
            (click)="$event.stopPropagation()" />
          <span class="checkmark"></span>
        </label>
        <!--
        <input type="checkbox" class="checkbox-round" [formControl]="ctx.flag.checkbox" class="form-control"
          (click)="$event.stopPropagation()" style="margin: 5px; width: 25px;" /> -->
      </div>
      <div class="no-picture no-picture-bg" (click)="editGroup(ctx.selectedGroup, ctx.flag)">
        <div style="flex: 1"></div>

        <div *ngIf="!ctx.flag.picture"><img src="assets/img/brand/Whiteblack-logo.png" alt="" /></div>

        <div *ngIf="ctx.flag.picture">
          <img
            style="cursor: pointer"
            class="thumb-markup"
            (click)="openPicture(ctx.flag); $event.stopPropagation()"
            [src]="ctx.flag.imageUrl" />
        </div>

        <div style="flex: 1"></div>
      </div>
    </div>
    <div class="flag-data" (click)="editGroup(ctx.selectedGroup, ctx.flag)">
      <div class="middle">
        <div class="flag-path d-flex justify-content-between gap-1 align-items-center flex-wrap">
          <div class="flex d-flex align-items-center flex-wrap gap-1">
            <span class="btn-flag-type btn backgroung-light-red rounded-pill mr-2">
              {{ ctx.flag.subtype?.type?.name }}
            </span>

            <span class="mr-2" style="flex: none">
              <span class="warning" *ngIf="true || !isCompleted(ctx.flag)">
                <i class="fa fa-warning"></i>
              </span>
              <span *ngIf="ctx.flag.score" class="score">
                {{ ctx.flag.score }}
              </span>
            </span>

            <span class="mr-2" style="max-width: 235px"> {{ ctx.flag.label }}</span>
          </div>

          <span class="btn btn-outline-danger btn-flag-deadline" *ngIf="ctx.flag.subtype?.type?.name == 'Violation'">
            <i class="fa fa-adjust" aria-hidden="true"></i> Deadline:
            {{ dateAsString(ctx.flag.violation.deadline) }}
          </span>
        </div>
        <p class="question-text question-truncate">
          {{ ctx.flag.question }}
          <br />
          <a>
            <span
              (click)="$event.stopPropagation()"
              [routerLink]="'/inspection/review/main/' + ctx.inspection?.id"
              [queryParams]="getLinkParams(ctx.flag)"
              queryParamsHandling="merge"
              >Show question</span
            >
          </a>
        </p>

        <div class="details">
          <div class="detail-label border-right-white">Issue description:</div>
          <div class="detail-content">{{ truncateString(ctx.flag.description) }}</div>
        </div>

        <div class="details" *ngIf="ctx.flag.subtype?.type?.name == 'Discrepancy'">
          <div>
            <div class="detail-label border-right-white">Comment:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.text) }}</div>
          </div>
          <div>
            <div class="detail-label border-right-white">Application Stated:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.discrepancy.stated) | extractText }}</div>
          </div>
          <div>
            <div class="detail-label border-right-white">Accurate Finding from Inspection:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.discrepancy.actual) | extractText }}</div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">Result of the findings:</div>
            <div class="detail-content">
              {{ truncateString(ctx.flag.discrepancy.resultOfTheFinding) | extractText }}
            </div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">Impact:</div>
            <div class="detail-content">{{ ctx.flag.discrepancy.impact | extractText }}</div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">Effective date:</div>
            <div class="detail-content">
              {{ dateAsString(ctx.flag.discrepancy.effectiveDate) }}
            </div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">Additional components for report:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.discrepancy.commentsForReport) | extractText }}</div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">URL:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.discrepancy.url) }}</div>
          </div>
        </div>

        <div class="details" *ngIf="ctx.flag.subtype?.type?.name == 'Violation'">
          <div>
            <div class="detail-label border-right-white">Comment:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.text) }}</div>
          </div>
          <div>
            <div class="detail-label border-right-white">Subtype:</div>
            <div class="detail-content">{{ truncateString(subtypeName(ctx.flag.subtype)) }}</div>
          </div>
          <div>
            <div class="detail-label border-right-white">Elevated Risk:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.violation.elevatedRisk) | extractText }}</div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">Why does this matter?</div>
            <div class="detail-content">{{ truncateString(ctx.flag.violation.whyDoesThisMatter) | extractText }}</div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">Actions requested:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.violation.actionRequested) | extractText }}</div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">Documentation Requested:</div>
            <div class="detail-content">
              {{ truncateString(ctx.flag.violation.documentationRequested) | extractText }}
            </div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">Internal notes:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.violation.internalNotes) | extractText }}</div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">URL:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.violation.url) }}</div>
          </div>
        </div>

        <p class="question-text">
          <a style="font-size: 14px">
            <br />
            <span (click)="showMore(ctx.flag.id); $event.stopPropagation()">
              {{ isExpanded(ctx.flag.id) ? 'Show less' : 'Show more' }}
            </span></a
          >
        </p>
        <div class="comments-section my-4 d-flex gap-1">
          <div
            *ngIf="ctx"
            class="border-1 border-gray100 d-flex align-items-center justify-content-between gap-2 p-3 w-50">
            <p class="m-0 text-left">
              Underwriting Comments
              <span class="text-primary">({{ ctx.flag.comments?.length ? ctx.flag.comments?.length : '0' }})</span>
            </p>
            <a
              [routerLink]="[]"
              class="text-primary"
              (click)="editGroup(ctx.selectedGroup, ctx.flag, 'comments'); $event.stopPropagation()"
              >{{ ctx.flag.comments?.length ? 'view all comments' : 'Add' }}</a
            >
          </div>

          <div class="border-1 border-gray100 d-flex align-items-center justify-content-between gap-2 p-3 w-50">
            <a
              class="text-dark"
              [routerLink]="[]"
              (click)="editGroup(ctx.selectedGroup, ctx.flag, 'comments-review'); $event.stopPropagation()">
              Review Comments <span class="text-primary">({{ getQuestionCommentsTotal(ctx.flag.questionId) }})</span></a
            >
          </div>
        </div>
        <div style="font-size: 14px; color: #7b8ead" class="my-4">
          <div style="font-size: 14px">
            <span class="text-dark">{{ ctx.flag.user?.name }} </span> ({{ dateTimeAsString(ctx.flag.updatedAt) }})
            <a
              style="font-size: 14px; margin-left: 30px; font-weight: 700; color: #2763cd"
              [routerLink]="[]"
              (click)="editGroup(ctx.selectedGroup, ctx.flag, 'changelog'); $event.stopPropagation()">
              View changelog
            </a>
          </div>
        </div>
        <div class="details-btn w-100 my-3">
          <button
            *ngIf="!ctx.flag.ignore"
            type="button"
            class="btn btn-sm aru btn-outline-danger"
            (click)="ignore(ctx.flag)">
            Ignore
          </button>
          <button
            *ngIf="ctx.flag.ignore"
            type="button"
            class="btn btn-sm aru btn-outline-success"
            (click)="restore(ctx.flag)">
            Keep
          </button>
          <button
            type="button"
            class="btn btn-sm aru btn-outline-primary"
            [ngClass]="{ completed: isCompleted(ctx.flag) }">
            <!-- <i *ngIf="isCompleted(ctx.flag)" class="fa fa-check" style="font-size: 20px;margin-right: 10px;"></i> -->
            Edit
          </button>
        </div>

        <div class="details" *ngIf="activeStep == 3">
          <div style="padding: 8px 15px; border: 1px solid #ddd; border-radius: 30px; margin: 10px 0">
            <div class="detail-label border-right-white" style="width: auto">Latest comment:</div>
            <div *ngIf="ctx.flag.comments?.length" class="detail-content">
              {{ ctx.flag.comments[ctx.flag.comments.length - 1].text }}
            </div>

            <span style="float: right">
              <a
                [routerLink]="[]"
                (click)="editGroup(ctx.selectedGroup, ctx.flag, 'comments'); $event.stopPropagation()"
                >{{ ctx.flag.comments?.length ? 'view all comments' : '+ Add a comment' }}</a
              >
            </span>
            <br style="clear: both" />
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #flagResolution let-ctx>
  <div class="flag-details kept-listing" [ngClass]="getFlagHighlightClass(ctx.flag)">
    <div class="flag-picture">
      <div style="position: absolute">
        <label class="checkbox-container">
          <input
            type="checkbox"
            class="checkbox-input"
            [formControl]="ctx.flag.checkbox"
            (click)="$event.stopPropagation()" />
          <span class="checkmark"></span>
        </label>
        <!-- <input type="checkbox" [formControl]="ctx.flag.checkbox" class="form-control" (click)="$event.stopPropagation()"
          style="margin: 5px; width: 25px;" /> -->
      </div>
      <div class="no-picture no-picture-bg" (click)="editGroup(ctx.selectedGroup, ctx.flag)">
        <div style="flex: 1"></div>
        <div *ngIf="!ctx.flag.picture"><img src="assets/img/brand/Whiteblack-logo.png" alt="" /></div>

        <div *ngIf="ctx.flag.picture">
          <img
            style="cursor: pointer"
            class="thumb-markup"
            (click)="openPicture(ctx.flag); $event.stopPropagation()"
            [src]="embeddedUrl(ctx.flag.picture) + '?'" />
        </div>

        <div style="flex: 1"></div>
      </div>
    </div>
    <div class="flag-data" (click)="editGroup(ctx.selectedGroup, ctx.flag)">
      <div class="middle">
        <div class="flag-path d-flex justify-content-between align-items-center gap-1 flex-wrap">
          <span class="flex d-flex align-items-center flex-wrap gap-1">
            <span class="btn-flag-type btn backgroung-light-red rounded-pill mr-2">
              {{ ctx.flag.subtype?.type?.name }}
            </span>
            <span class="mr-2" style="display: inline-block">
              <span class="warning" *ngIf="true || !isCompleted(ctx.flag)">
                <i class="fa fa-warning"></i>
              </span>
              <span *ngIf="ctx.flag.score" class="score">
                {{ ctx.flag.score }}
              </span>
            </span>
            <span class="mr-2" style="max-width: 235px"> {{ ctx.flag.label }}</span>
          </span>

          <div class="flag-dates" class="btn btn-outline-danger btn-flag-deadline">
            <div
              *ngIf="ctx.flag.subtype?.type?.name == 'Violation'"
              [ngClass]="{ red: ctx.flag.status !== FlagStatus.RESOLVED && dateIsPast(ctx.flag.violation.deadline) }">
              <i class="fa fa-adjust" aria-hidden="true"></i>
              Deadline: {{ dateAsString(ctx.flag.violation.deadline) }}
            </div>
            <br *ngIf="ctx.flag.resolved && ctx.flag.subtype?.type?.name == 'Violation'" />
            <div *ngIf="ctx.flag.resolved" class="--flag-resolved-date">
              Resolved: {{ dateAsString(ctx.flag.resolved) }}
            </div>
          </div>
        </div>
        <p class="question-text" style="max-width: 45em">
          <span> {{ ctx.flag.question }}</span>
          <a style="font-size: 14px">
            <br />
            <span
              (click)="$event.stopPropagation()"
              [routerLink]="'/inspection/review/main/' + ctx.inspection?.id"
              [queryParams]="getLinkParams(ctx.flag)"
              queryParamsHandling="merge">
              Show question</span
            ></a
          >
        </p>

        <!-- <div class="my-2">
          <div class="detail-label border-right-white">Issue description:</div>
          <div class="detail-content " style="
                 max-width: 45rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
              ">{{ctx.flag.description}}</div>
        </div> -->

        <div class="details" *ngIf="ctx.flag.subtype?.type?.name == 'Legacy'" style="height: 120px"></div>
        <div class="details" *ngIf="ctx.flag.subtype?.type?.name == 'Discrepancy'">
          <div>
            <div class="detail-label border-right-white">Comment:</div>
            <div class="detail-content">{{ ctx.flag.text }}</div>
          </div>
          <div>
            <div class="detail-label border-right-white">Application Stated:</div>
            <div class="detail-content">{{ ctx.flag.discrepancy.stated | extractText }}</div>
          </div>
          <div>
            <div class="detail-label border-right-white">Accurate Finding from Inspection:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.discrepancy.actual) | extractText }}</div>
          </div>
          <div>
            <div class="detail-label border-right-white">Result of the findings:</div>
            <div class="detail-content">
              {{ truncateString(ctx.flag.discrepancy.resultOfTheFinding) | extractText }}
            </div>
          </div>
          <div>
            <div class="detail-label border-right-white">Impact:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.discrepancy.impact) | extractText }}</div>
          </div>
          <div>
            <div class="detail-label border-right-white">Effective date:</div>
            <div class="detail-content">
              {{ truncateString(dateAsString(ctx.flag.discrepancy.effectiveDate)) }}
            </div>
          </div>
          <div>
            <div class="detail-label border-right-white">Additional components for report:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.discrepancy.commentsForReport) | extractText }}</div>
          </div>
          <div>
            <div class="detail-label border-right-white">URL:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.discrepancy.url) }}</div>
          </div>
        </div>

        <div class="details" *ngIf="ctx.flag.subtype?.type?.name == 'Violation'">
          <div>
            <div class="detail-label border-right-white">Comment:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.text) }}</div>
          </div>
          <div>
            <div class="detail-label border-right-white">Subtype:</div>
            <div class="detail-content">{{ truncateString(subtypeName(ctx.flag.subtype)) }}</div>
          </div>
          <div>
            <div class="detail-label border-right-white">Elevated Risk:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.violation.elevatedRisk) | extractText }}</div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">Why does this matter?</div>
            <div class="detail-content">{{ truncateString(ctx.flag.violation.whyDoesThisMatter) | extractText }}</div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">Actions requested:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.violation.actionRequested) | extractText }}</div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">Documentation Requested:</div>
            <div class="detail-content">
              {{ truncateString(ctx.flag.violation.documentationRequested) | extractText }}
            </div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">Internal notes:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.violation.internalNotes) | extractText }}</div>
          </div>
          <div *ngIf="isExpanded(ctx.flag.id)">
            <div class="detail-label border-right-white">URL:</div>
            <div class="detail-content">{{ truncateString(ctx.flag.violation.url) }}</div>
          </div>
        </div>

        <p class="question-text">
          <a style="font-size: 14px">
            <br />
            <span (click)="showMore(ctx.flag.id); $event.stopPropagation()">
              {{ isExpanded(ctx.flag.id) ? 'Show less' : 'Show more' }}
            </span>
          </a>
        </p>
        <div class="comments-section my-4 d-flex gap-1" *ngIf="activeStep == 3">
          <div class="border-1 border-gray100 d-flex align-items-center justify-content-between gap-2 p-3 w-50">
            <p class="m-0 text-left">
              Underwriting Comments
              <span class="text-primary">({{ ctx.flag.comments?.length ? ctx.flag.comments?.length : '0' }})</span>
              <!-- <span
                *ngIf="ctx.flag.comments?.length">{{ctx.flag.comments[ctx.flag.comments.length -1].text}}</span> -->
            </p>
            <a
              [routerLink]="[]"
              (click)="editGroup(ctx.selectedGroup, ctx.flag, 'comments'); $event.stopPropagation()"
              >{{ ctx.flag.comments?.length ? 'view all' : 'Add' }}</a
            >
          </div>

          <div class="border-1 border-gray100 d-flex align-items-center justify-content-between gap-2 p-3 w-50">
            <a
              class="text-dark"
              [routerLink]="[]"
              (click)="editGroup(ctx.selectedGroup, ctx.flag, 'comments-review'); $event.stopPropagation()">
              Review Comments <span class="text-primary">({{ getQuestionCommentsTotal(ctx.flag.questionId) }})</span>
            </a>
          </div>
        </div>

        <div style="font-size: 14px; color: #7b8ead" class="my-4">
          <div style="font-size: 14px">
            <span class="text-dark">{{ ctx.flag.user?.name }} </span> ({{ dateTimeAsString(ctx.flag.updatedAt) }})
            <a
              style="font-size: 14px; margin-left: 30px; font-weight: 700; color: #2763cd"
              [routerLink]="[]"
              (click)="editGroup(ctx.selectedGroup, ctx.flag, 'changelog'); $event.stopPropagation()">
              View changelog
            </a>
          </div>
        </div>

        <div class="flag-status-buttons">
          <ng-container *ngIf="ctx.flag.status == FlagStatus.UNRESOLVED">
            <button
              type="button"
              class="btn btn-sm aru btn-outline-success"
              (click)="changeFlagStatus(ctx.flag, FlagStatus.RESOLVED); $event.stopPropagation()">
              Resolved
            </button>

            <button
              type="button"
              class="btn btn-sm aru btn-outline-warning"
              (click)="changeFlagStatus(ctx.flag, FlagStatus.PARTIAL_RESPONSE); $event.stopPropagation()">
              Partial Response
            </button>
          </ng-container>
        </div>

        <div class="flag-status-buttons" *ngIf="ctx.flag.status == FlagStatus.PARTIAL_RESPONSE">
          <button
            *ngIf="ctx.flag.status == FlagStatus.PARTIAL_RESPONSE"
            type="button"
            class="btn aru btn-outline-success"
            (click)="changeFlagStatus(ctx.flag, FlagStatus.RESOLVED); $event.stopPropagation()">
            Resolved
          </button>

          <button
            type="button"
            class="btn btn-sm aru btn-outline-danger"
            (click)="changeFlagStatus(ctx.flag, FlagStatus.UNRESOLVED); $event.stopPropagation()">
            Unresolved
          </button>
        </div>

        <div class="flag-status-buttons" *ngIf="ctx.flag.status == FlagStatus.RESOLVED">
          <button
            type="button"
            class="btn btn-sm aru btn-outline-danger"
            (click)="changeFlagStatus(ctx.flag, FlagStatus.UNRESOLVED); $event.stopPropagation()">
            Unresolved
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-set-violation-deadlines #setDeadlinesModal></app-set-violation-deadlines>

<app-flag-group-template
  #flagGroupTemplateModal
  [flagGroupTags]="flagGroupTags"
  [inspectionId]="inspection?.id"
  [createGroup]="true"
  [expand]="false"
  [CreateGroup]="false"
  (editGroup)="editGroupByTemplate($event)"
  (messageEvent)="createGroup($event)">
</app-flag-group-template>

<app-extension-granted-deadlines
  #ExtensionGrantedDeadlinesModal
  [selectedFlags]="selectedFlags"></app-extension-granted-deadlines>
